/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CoverageUsed/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function CoverageUsed({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/CoverageUsed",
  onChange,
  isInvalid
  
}) {
let globalCurrentLocationPermissionsHasPatientInsuranceEditValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'current_location.permissions.has_patient_insurance_edit',
format: fromFormat.not,
})
let txCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData = fromData.useDataValue({ viewPath,
context: 'tx_category_insured',
path: 'ortho_insured.used_lifetime_coverage',
})
let txCategoryInsuredOrthoInsuredUsedLifetimeCoverageIsValidData = fromData.useDataIsValid({ viewPath,
context: 'tx_category_insured',
path: 'ortho_insured.used_lifetime_coverage',
validate: fromValidate.numberZeroOrPositive,
required: true,
})
let txCategoryInsuredOrthoInsuredUsedLifetimeCoverageChangeData = fromData.useDataChange({ viewPath,
context: 'tx_category_insured',
path: 'ortho_insured.used_lifetime_coverage',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="global.current_location.permissions.has_patient_insurance_edit"
 format="/Data/format.js not"
 disabled={globalCurrentLocationPermissionsHasPatientInsuranceEditValueData}
 type="number"
 data="tx_category_insured.ortho_insured.used_lifetime_coverage"
 value={txCategoryInsuredOrthoInsuredUsedLifetimeCoverageValueData}
 onChange={txCategoryInsuredOrthoInsuredUsedLifetimeCoverageChangeData}
 validate="/Data/validate.js numberZeroOrPositive"
 isInvalid={!txCategoryInsuredOrthoInsuredUsedLifetimeCoverageIsValidData}
 required={true}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Coverage Used"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}